import React, { useMemo, useEffect, useState } from 'react';
import { mergeStyleSets } from '@fluentui/react';

import { TargetPickerButton } from 'src/components/base/TargetPicker';

import { toSubstitution } from 'shared/utils/querySubstitution';


export const classNames = mergeStyleSets({
  withTargetPicker: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'stretch',
  },
});


export const SubstitutionPicker = ({ disabled, showPicker = false, formatSelection = defaultFormat, onChange }) => {
  if (!showPicker) {
    return null;
  }
  
  function handleTargetChanged(selection) {
    onChange(formatSelection(selection));
  }

  return <TargetPickerButton disabled={disabled} selectionOnly={true} onChange={handleTargetChanged}/>
}

export function defaultFormat(selection) {
  return toSubstitution({ address: selection.addresses[0].address })
}


